import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { Wrapper5, LocalService, Status, TriggeredEvent, KeyValues5 } from '../../../service/local.service';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss']
})
export class LanguageComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["language_popup"];
  wrapper: Wrapper5; maxBodyHeight = 0;
  id: string;
  elementIds = {
    language_id:'language_title_equi'
  }
  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.languageManagementService.saveLanguage(this.wrapper).subscribe(result => {      
      if (result.status == Status.Success) {
        this.wrapper.content.key = this.id == '' ? result.id : this.id;
        this.activeModal.close({ event: TriggeredEvent.Ok, wrapper: this.wrapper });
      } else {
        this.localService.showMessageByStatus(result.status);
      }
    });
  }

  onLoad() {
    if (this.id != '') {
      this.languageManagementService.getLanguage(this.id).subscribe(result => {
        this.wrapper = result;        
      });
    } else {
      this.wrapper = {
        languageContents: null,
        content: { key: '', v1: '', v2: '', v3: '', v4: '', v5: '' } as KeyValues5
      } as Wrapper5;
    }
  }

  onEmptyLanguageContainerAdded(languageContents: any) {
    this.wrapper.languageContents = languageContents;
  }
}
